import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { AnToastService } from '@autonation/dt-an-components-lib/an-toast'
import { VehicleDetailsService } from '../../../services/vehicle-details.service';
import { PricingStack } from '../../../utils/pricing-stack';
import { FormInfoService } from '../../../services/form-info.service';

@Component({
    selector: 'an-favorite-tile',
    templateUrl: './favorite-tile.component.html',
    styleUrls: ['./favorite-tile.component.scss'],
    standalone: false
})
export class FavoriteComponent implements OnInit, AfterViewInit {
  @Input('vehicleDetails')
  vehicleDetails: any;
  @Input('stateData')
  stateData: any;
  pricingInfo:any;

  constructor(public changeDetectorRef: ChangeDetectorRef,
    private _toastService: AnToastService,
    private formInfoService: FormInfoService,
    private _vehicleDetailService: VehicleDetailsService) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }
  displayModel(makeModel: string) {
    if (makeModel && makeModel.indexOf('^^^') !== -1) {
      return makeModel.split('^^^')[1] || 'Other';
    } else {
      return makeModel;
    }
  }

  tileLinkUrl(vehicleDetails) {
    if(vehicleDetails.DealPending) {
      const url = `/my-account/my-vehicle?vin=${vehicleDetails.Vin}`;
      return url;
    }
    const vin = vehicleDetails.Vin || 'Vin'
    return ('/cars/') + vin; 
  }

  calculatePhoto(vehicle: any) {
    let url = '';
    if(vehicle.rawPhotoUrl) {
      url = vehicle.rawPhotoUrl;
    } else {
      url = vehicle.photoUrl;
    }   
    if (url) {
      url = url.replace('[w]x[h]', '392x294');
    }

    return 'https:' + url;
  }

  isStockTypeNew(vehicle: any) {
    const stock = vehicle.stockType || '';
    return stock.toLowerCase() === 'new';
  }

  checkVehStatusDesc = (vehicle: any) => {
    if (vehicle.DealPending) {
      return 'dealpending';
    } else if (vehicle.inventoryStatus === 'ANR') {
      return 'reserve';
    } else {
      return '';
    }
  }

  checkReserved = (vehicle: any, val: boolean) => {
   if (vehicle.inventoryStatus === 'ANR') {
      return val ? 'Reserved': 'reserve';
    } else {
      return '';
    }
  }

  getVehicleStatusdesc = (vehicle: any) => {
    if (vehicle.DealPending) {
      return 'Deal Pending';
    } else if (vehicle.inventoryStatus === 'ANR') {
      return 'Reserved';
    } else {
      return '';
    }
  }
  getPrice(vehicle?: any) {
      this.pricingInfo = this.getPriceNodeInfo(vehicle)
      return this.pricingInfo? this.pricingInfo.Value !== null ? this.pricingInfo.Value : '' : '';
      }

  getName(vehicle?: any) {
    this.pricingInfo = this.getPriceNodeInfo(vehicle)
    if(this.pricingInfo && this.pricingInfo.Value !== null && this.pricingInfo.Name === 'AutoNationPrice' ){
      return 'AutoNation Price';
    }else{
      return this.pricingInfo ? this.pricingInfo.Value !== null ? this.pricingInfo.DisplayName ? this.getDisplayName(this.pricingInfo.DisplayName) : this.pricingInfo.Name : '' : '';
    }
  }

  getDisplayName(displayName) {
    return this.stateData?.[displayName] ?? '';
  }
  formattedMileage(mileage) {
    return Math.round(parseInt(mileage, null) / 1000).toString() + 'K';
  }

  removeFavorites(vehicleDetails: any): any {
    this._vehicleDetailService.removeFromFav(vehicleDetails);
    this.formInfoService.heartLinkCall();

  }

  tealiumCallvehicleDetails(carName: string) {
    let carNameTrimmed;
    if (this.vehicleDetails && this.vehicleDetails.model.indexOf('^') > -1) {
      carNameTrimmed = this.vehicleDetails.year + ' ' + this.vehicleDetails.make + ' ' + this.vehicleDetails.model.split('^^^')[1];
    } else {
      carNameTrimmed = carName;
    }
    this.formInfoService.vehicleClickLinkCall(carNameTrimmed);
  }

  pricingStackView(vehicleDetails: any): any {
    this.pricingInfo = this.getPriceNodeInfo(vehicleDetails);
    const pricingName = vehicleDetails && this.pricingInfo ? this.pricingInfo.Name.toLowerCase() : '';
    switch (pricingName) {
      case PricingStack.MsrpPrice: {
        return 0
      }
      case PricingStack.AutonationPrice: {
        return 1
      }
      case PricingStack.HighDemand: {
        return 2
      }
      case PricingStack.PendingSale: {
        return 3
      }
      case PricingStack.CallForPrice: {
        return 4
      }
      default:
        return -1;

    }
  }

  getToolTipData(vehicleDetails: any, desc: boolean, price?: boolean) {
    const val = this.checkVehStatusDesc(vehicleDetails);
    if (price) {
      if (this.pricingStackView(vehicleDetails) === 1) {
        return desc ? this.stateData.OnePriceBody : this.stateData.OnePriceHeader;
      }
    }
    if (val === 'reserve') {
      return desc ? this.stateData.ReservedBody : this.stateData.ReservedHeader;
    } else if (val === 'dealpending') {
      return desc ? this.stateData.DealPendingBody : this.stateData.DealPendingHeader;
    }

  }

  getToolTipDataReserved(desc: boolean) {
    return desc ? this.stateData.ReservedBody : this.stateData.ReservedHeader;
  }

  getPriceNodeInfo(vehicleDetails) : any{
    let priceNodeInfo;
    const priceNodes=vehicleDetails?.pricingInfo;
     priceNodeInfo = priceNodes?.find(item => item.Type === 0)
    if(priceNodeInfo == null){
     priceNodeInfo = priceNodes?.find(item => item.Type === 1)
    }
    return priceNodeInfo;
  }
}
